<template>
  <div class="page-boxed page-header-fixed page-sidebar-closed-hide-logo page-container-bg-solid">
    <div>
      <AdminHeader></AdminHeader>
      <div class="clearfix"></div>
      <div class="page-container">
        <Side></Side>
        <div class="page-content-wrapper">
          <div class="page-content">
            <router-view name="admin"></router-view>
          </div>
          <AdminFooter></AdminFooter>
        </div>
      </div>
    </div>
    <div class="initial" style="display:none;" id="loader">
      <div class="load-bg">
        <div class="load">
          <hr>
          <hr>
          <hr>
          <hr>
          <div class="loadback"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import AdminFooter from '../components/admin/Footer.vue'
import AdminHeader from '../components/admin/Header.vue'
import Side from '../components/admin/Side.vue'
import SearchDialog from '../components/admin/SearchDialog.vue'
import SearchEmailDialog from '../components/admin/SearchEmailDialog.vue'
import VueHead from 'vue-head'

Vue.use(VueHead)

export default {
  head: {
    link: [
      // {rel: 'stylesheet', href: '/static/admin/bootstrap/css/bootstrap.min.css'},
      {rel: 'stylesheet', href: '/static/lib/font-awesome/css/font-awesome.min.css'},
      {rel: 'stylesheet', href: '/static/lib/simple-line-icons/simple-line-icons.min.css'},
      {rel: 'stylesheet', href: '/static/admin/css/themes/default.css'},
      {rel: 'stylesheet', href: '/static/admin/css/admincustom.css'},
      {rel: 'stylesheet', href: '/static/admin/css/components.css'},
      {rel: 'stylesheet', href: '/static/admin/css/layout.css'},
      {rel: 'stylesheet', href: '/static/admin/css/themes/grey.css'}
      // {rel: 'stylesheet', href: '/static/admin/css/custom-fontawesome.css'}
    ]
  },
  components: {AdminFooter, AdminHeader, Side, SearchDialog, SearchEmailDialog}
}
</script>

<style scoped>
  .date-c-picker {
    z-index: 40000 !important;
  }

  .portlet > .portlet-title > .caption > i {
    color: #2386CA;
    font-size: 19px;
  }

  .search-c-filter {
    margin-top: 5px !important;
  }

  .caption-subject {
    float: left;
  }

  .blue-stripe {
    border-left: 2px solid #3598dc;
  }

  .margin-c2-bottom {
    margin-bottom: 5px;
  }

  #search_filter_form {
    padding: 5px 9px 5px 9px;
  }

  .feeds li {
    color: #333333;
    font-size: 15px;
  }

  .feeds li .col2 {
    float: left;
    width: 154px;
    margin-left: -154px;
  }

  .load-bg {
    height: 100%;
    display: block;
    width: 100%;
    min-height: 100vh;
    position: fixed;
    z-index: 999;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  .load {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    /*change these sizes to fit into your project*/
    width: 60px;
    height: 60px;
    z-index: 10000;
  }

  .load hr {
    background: rgb(207, 208, 208);

    border: 0;
    margin: 0;
    width: 40%;
    height: 40%;
    position: absolute;
    border-radius: 50%;
    -webkit-animation-name: spin;
    -webkit-animation-duration: 2000ms;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-timing-function: ease;
    -moz-animation-name: spin;
    -moz-animation-duration: 2000ms;
    -moz-animation-iteration-count: infinite;
    -moz-animation-timing-function: ease;
    -ms-animation-name: spin;
    -ms-animation-duration: 2000ms;
    -ms-animation-iteration-count: infinite;
    -ms-animation-timing-function: ease;

    animation-name: spin;
    animation-duration: 2000ms;
    animation-iteration-count: infinite;
    animation-timing-function: ease;

    z-index: 9999;
  }

  .load :first-child{
    background:#47BEEE;
    animation-delay:-1.5s;
    -webkit-animation-delay:-1.5s;
    -moz-animation-delay:-1.5s
  }
  .load :nth-child(2){
    background:#F03760;
    animation-delay:-1s;
    -webkit-animation-delay:-1s;
    -moz-animation-delay:-1s
  }
  .load :nth-child(3){
    background:#81EAA5;
    animation-delay:-0.5s;
    -webkit-animation-delay:-0.5s;
    -moz-animation-delay:-0.5s
  }
  .load :nth-child(4){
    background:#B5A7FD
  }

  .loadback {
    position: absolute;
    width: 10000px;
    height: 1000px;
    top: -500px;
    bottom: -9px;
    right: -1000px;
    z-index: 9998;
  }

  @-ms-keyframes spin {
    0%, 100% {
      -ms-transform: translate(0);
    }
    25% {
      -ms-transform: translate(160%);
    }
    50% {
      -ms-transform: translate(160%, 160%);
    }
    75% {
      -ms-transform: translate(0, 160%);
    }
  }

  @-moz-keyframes spin {
    0%, 100% {
      -moz-transform: translate(0);
    }
    25% {
      -moz-transform: translate(160%);
    }
    50% {
      -moz-transform: translate(160%, 160%);
    }
    75% {
      -moz-transform: translate(0, 160%);
    }
  }

  @-webkit-keyframes spin {
    0%, 100% {
      -webkit-transform: translate(0);
    }
    25% {
      -webkit-transform: translate(160%);
    }
    50% {
      -webkit-transform: translate(160%, 160%);
    }
    75% {
      -webkit-transform: translate(0, 160%);
    }
  }

  @keyframes spin {
    0%, 100% {
      transform: translate(0);
    }
    25% {
      transform: translate(160%);
    }
    50% {
      transform: translate(160%, 160%);
    }
    75% {
      transform: translate(0, 160%);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AdminPanel.vue